import { ChangeDetectionStrategy, Component, effect, input, OnDestroy, output, signal } from '@angular/core';

@Component({
  selector: 'app-session-warning-modal',
  templateUrl: './session-warning-modal.component.html',
  styleUrls: ['./session-warning-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionWarningModalComponent implements OnDestroy {
  readonly showCountdown = input<boolean>(false);
  readonly continueSession = output<void>();
  readonly handleLogout = output<void>();

  readonly countdown = signal<number>(60);
  private countdownInterval?: ReturnType<typeof setInterval>;

  constructor() {
    effect(() => {
      if (this.showCountdown()) {
        this.startCountdown();
      } else {
        this.clearCountdownInterval();
        this.countdown.set(60);
      }
    });
  }

  startCountdown() {
    this.clearCountdownInterval();
    this.countdown.set(60);
    this.countdownInterval = setInterval(() => {
      if (this.countdown() > 0) {
        this.countdown.update(v => v - 1);
      } else {
        this.clearCountdownInterval();
        this.handleLogout.emit();
      }
    }, 1000);
  }

  clearCountdownInterval() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = undefined;
    }
  }

  ngOnDestroy() {
    this.clearCountdownInterval();
  }
}
